<template>
  <v-container class="justify-center align-center fill-height">
    <div class="display-4">404</div>
  </v-container>
</template>

<script>
export default { name: "404" };
</script>
